import React from 'react';
import { motion } from 'framer-motion';
import { CTAButton } from './CTAButton';
const benefitRows = [['✅ 6 Premium Volumes', '✅ 5 Bonus Guides FREE'], ['✅ 610+ Pages', '✅ 55-Page Printable Resource Library'], ['✅ Constellation Maps & Systemic Mapping Tools', '✅ 200+ Printable Cards & Prompts']];
export const mockupUrl = 'https://cdn.magicpatterns.com/uploads/e3CUks3YpSTQ5arhC1QBrH/MOCKUP_CONS_PREMIUM_BORDES_REDONDEADOS.webp';
export function Hero() {
  return <>
    <section className="w-full bg-mist px-4 py-4 text-navy sm:py-6" data-id="element-112" data-mp="1274l9hahx23j">
      <div className="mx-auto max-w-5xl text-center" data-id="element-113" data-mp="xb5tdjpyl1yd">
        <motion.span initial={{
          opacity: 0,
          y: -10
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.45
        }} className="inline-flex rounded-full border border-amber/50 bg-surface px-4 py-1.5 text-[10px] font-bold uppercase tracking-[0.12em] text-amber" data-id="element-114" data-mp="sartioyigybf">Family Healing</motion.span>
        <motion.h1 initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.05
        }} className="mx-auto mt-3 max-w-3xl font-serif text-4xl leading-[0.98] tracking-tight text-navy sm:text-6xl" data-id="element-115" data-mp="384s6grzq2r4n">Therapeutic Family Constellations™</motion.h1>
        <motion.p initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.16
        }} className="mx-auto mt-3 max-w-md text-sm leading-snug text-slate sm:text-base" data-id="element-116" data-mp="3e84n7bv46wu1">Order your system. Save your history. Ready-to-use constellation maps, healing scripts, genogram templates, and printable resources to break generational patterns and rewrite your family story — forever.</motion.p>
        <motion.div initial={{
          opacity: 0,
          y: 18
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.2
        }} className="mx-auto mt-5 max-w-3xl text-center" data-id="element-117" data-mp="2hkgl23bg7ew4">
          <p className="text-xs font-bold uppercase tracking-[0.12em] text-amber" data-id="element-118" data-mp="nat7pcgomml8">📦 Everything You Get Instantly</p>
          <div className="mt-2 space-y-1 text-xs font-medium text-slate sm:text-sm" data-id="element-119" data-mp="ibgiwm6935g0">{benefitRows.map(row => <p key={row.join('-')} className="flex flex-wrap justify-center gap-x-5 gap-y-1" data-id="element-120" data-mp="ddwyt5mvfyg5">{row.map(benefit => <span key={benefit} data-id="element-121" data-mp="1b15prg5n5zpj">{benefit}</span>)}</p>)}</div>
        </motion.div>
        <motion.div initial={{
          opacity: 0,
          y: 16
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.55,
          delay: 0.26
        }} className="mx-auto mt-5 max-w-3xl" data-id="element-122" data-mp="1622l3wtkpvi3"><img src={mockupUrl} alt="Therapeutic Family Constellations complete healing system mockup" fetchPriority="high" decoding="async" className="mx-auto block h-auto w-full max-w-2xl rounded-3xl object-contain shadow-elevated" data-id="element-123" data-mp="x0crqlg4smho" /></motion.div>
        <motion.div initial={{
          opacity: 0,
          y: 12
        }} animate={{
          opacity: 1,
          y: 0
        }} transition={{
          duration: 0.5,
          delay: 0.32
        }} className="mt-5" data-id="element-124" data-mp="1x9b590wn91ck"><CTAButton href="#complete-package" pulse size="large" data-id="element-125" data-mp="269hbq2txd128">GET INSTANT ACCESS</CTAButton><p className="mx-auto mt-3 max-w-3xl text-xs leading-relaxed text-slate sm:text-sm" data-id="element-126" data-mp="2b0pptc679alq">📄 High-Quality PDF <span className="mx-1" data-id="element-127" data-mp="2g02k2hzehjyc">·</span> 🖨️ Printable Resources <span className="mx-1" data-id="element-128" data-mp="2fzarzh50i4ct">·</span> ⚡ Instant Download <span className="mx-1" data-id="element-129" data-mp="2kydv2w1fm0i5">·</span> 🔒 Secure Payment <span className="mx-1" data-id="element-130" data-mp="2kx2f7xupp2ao">·</span>  🛡️ 7-Day Purchase Protection</p></motion.div>
      </div>
    </section>
    <section className="border-y border-amber/40 bg-surface px-4 py-5 text-navy" data-id="element-131" data-mp="2oye7kb4z01mk"><div className="mx-auto max-w-3xl text-center" data-id="element-132" data-mp="2tyaae71xln0j"><p className="text-sm font-bold sm:text-base" data-id="element-133" data-mp="umhekdqvqnpe">🚀 Launch offer active — All 5 Bonus Guides FREE with purchase · Price increases when the timer hits zero</p><div className="mx-auto mt-3 h-2 max-w-xl overflow-hidden rounded-full bg-amber/20" data-id="element-134" data-mp="zm2nngzrkcfu"><div className="h-full w-[72%] rounded-full bg-amber" data-id="element-135" data-mp="4acnbfstvv90" /></div><p className="mt-2 text-xs font-medium text-slate" data-id="element-136" data-mp="3vhp4hutpo8ox">72% of launch spots already claimed</p></div></section>
  </>;
}